import {
  ApiError,
  apiService,
  ClientDeviceType,
  Config,
  Game,
  getConfig,
  SDKConfig,
  Stream,
  UserConfig,
} from "@blacknut/javascript-sdk/dist";
import { logD, logE } from "@blacknut/logging/dist";
import { createContext, Fragment, useContext, useEffect, useState } from "react";
import { PropsWithChildren } from "react";
import { LOGGING_TAG } from "./logging";
import UAParser from "ua-parser-js";
import { inputUI } from "@blacknut/spatialnav-sdk/dist";
import React from "react";
export declare type AppContextT = {
  config: Config | undefined;
  setConfig: (config: Config | undefined) => void;

  game?: Game;
  setGame: (game?: Game) => void;

  stream?: Stream;
  setStream: (stream: Stream) => void;

  sdkConfig?: SDKConfig;

  streamUserConf?: UserConfig;
  setStreamUserConf: (conf: UserConfig) => void;
};
export const AppContext = createContext<AppContextT>({
  config: undefined,
  setConfig: () => {
    console.warn("nop");
  },
  game: undefined,
  setGame: () => {
    console.warn("nop");
  },
  stream: undefined,
  setStream: () => {
    console.warn("nop");
  },
  sdkConfig: undefined,
  streamUserConf: undefined,
  setStreamUserConf: () => {
    console.warn("nop");
  },
});

export const ContextProvider = ({
  config: inConfig,
  game: inGame,
  stream: inStream,
  sdkConfig: inSdkConfig,
  children,
}: PropsWithChildren<{
  sdkConfig: SDKConfig;
  config?: Config;
  game?: Game;
  stream?: Stream;
}>) => {
  const [config, setConfig] = useState<Config | undefined>(inConfig);
  const [game, setGame] = useState<Game | undefined>(inGame);
  const [stream, setStream] = useState<Stream | undefined>(inStream);
  const [streamUserConf, setStreamUserConf] = useState<UserConfig>();

  useEffect(() => {
    if (!config) {
      if (!apiService.userAgent.brand && !apiService.userAgent.model) {
        const parser = new UAParser(navigator.userAgent); // you need to pass the user-agent for nodejs
        console.log(parser.getResult()); // {}
        apiService.userAgent = {
          ...apiService.userAgent,
          brand: parser.getResult().device.vendor,
          model: parser.getResult().device.model,
        };
      }

      getConfig().subscribe({
        next: (config) => {
          // setConfig({
          //   ...config,
          //   features: { ...config.features, ericssonBoostSubscribed: true },
          // });

          if (config.deviceKind !== apiService.userAgent.client) {
            logD(
              LOGGING_TAG,
              "Override client with server value :%o",
              config.deviceKind,
            );
            apiService.userAgent = {
              ...apiService.userAgent,
              client: config.deviceKind,
            };
          }
          setConfig(config);

          inputUI.pollingIntervalGame = config.userConf?.gamepadPollingIntervalGame;
          inputUI.pollingIntervalUI = config.userConf?.gamepadPollingIntervalEdito;
        },
        error: (err: ApiError) => {
          logE(LOGGING_TAG, "Error getting config", err);
        },
      });
    }
  }, [config]);
  return (
    <AppContext.Provider
      value={{
        config,
        setConfig,
        game,
        setGame,
        stream,
        setStream,
        sdkConfig: inSdkConfig,
        streamUserConf,
        setStreamUserConf,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
